import {
  EmbedIframeCodeBuilderOptions,
  EmbedURLBuilderOptions
} from "./types"

const EMBED_HEX_COLOR_RE = /^[0-9a-f]{6}$/i
const EMBED_TRUE_VALUE_SET = new Set(["1", "true", "yes", "on"])

const getEmbedBaseUrl = (baseUrl?: string) => {
  if (baseUrl) return baseUrl
  if (typeof window !== "undefined") return window.location.origin
  return "https://www.pathwright.com"
}

const normalizeEmbedFeatureKey = (featureKey: string): string =>
  featureKey.replace(/^\/+|\/+$/g, "")

export const getEmbedPath = (featureKey: string): string =>
  `/embed/${normalizeEmbedFeatureKey(featureKey)}/`

export const getEmbedURL = ({
  featureKey,
  baseUrl,
  queryParams
}: EmbedURLBuilderOptions): URL => {
  const embedUrl = new URL(getEmbedPath(featureKey), getEmbedBaseUrl(baseUrl))
  if (queryParams) {
    embedUrl.search = queryParams.toString()
  }
  return embedUrl
}

export const getEmbedIframeCode = ({
  width = "100%",
  height = 420,
  title,
  ...embedUrlOptions
}: EmbedIframeCodeBuilderOptions): string => {
  const embedUrl = getEmbedURL(embedUrlOptions)
  const titleAttr = title ? ` title="${title}"` : ""
  return `<iframe src="${embedUrl.toString()}"${titleAttr} width="${width}" height="${height}" style="border:0;overflow:hidden;" loading="lazy"></iframe>`
}

export const parseEmbedBooleanParam = (
  value: string | null,
  defaultValue = false
): boolean => {
  if (value === null) return defaultValue
  return EMBED_TRUE_VALUE_SET.has(value.toLowerCase())
}

export const normalizeEmbedHexColor = (
  value?: string | null
): string | null => {
  if (!value) return null
  const normalizedValue = value.trim().replace(/^#/, "")
  if (!EMBED_HEX_COLOR_RE.test(normalizedValue)) return null
  return `#${normalizedValue}`
}

export const serializeEmbedHexColor = (
  value?: string | null
): string | null => {
  const normalizedColor = normalizeEmbedHexColor(value)
  return normalizedColor ? normalizedColor.slice(1) : null
}

export const normalizeEmbedPrimaryColor = normalizeEmbedHexColor
export const serializeEmbedPrimaryColor = serializeEmbedHexColor
export const normalizeParamColorHex = normalizeEmbedHexColor
